import React from 'react';
import { defaultArgs } from './constants';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi';
import {
  FooterLayout,
  toFooterNavProps,
  toSocialsProps,
  toPaymentProvidersProps,
  toFooterLegalsProps,
} from '@jbhi-fi/components/src/FooterLayout';
import { serviceHelper } from '../../../config/service-helper';
import { NavItem } from '@jbhi-fi/components/src/FooterLayout/types';
import { useContentfulActiveNavs } from '@jbhi-fi/components/src/hooks/useContentfulActiveNavs/useContentfulActiveNavs';
import he from 'he';

const contentfulClient = new ContentfulThemeApiClient({
  themeApiBaseUrl: serviceHelper.themeApisUrl,
});

export const Footer = () => {
  const { footerNav, footerSocials, footerLegals, footerPayments } = useContentfulActiveNavs({
    contentfulThemeApiClient: contentfulClient,
  });

  if (!footerNav?.fields) {
    return null;
  }

  const legalsProps = footerLegals?.fields ? toFooterLegalsProps(footerLegals) : undefined;
  const privacyLink = legalsProps?.legalsLinks?.find(
    (navItem: NavItem) => navItem.label.toLowerCase() === 'privacy policy'
  )?.url;

  return (
    <FooterLayout
      subscribeProps={{ ...defaultArgs.subscribeProps, privacyLink }}
      navigationProps={footerNav?.fields ? toFooterNavProps(footerNav) : undefined}
      socialsProps={footerSocials?.fields ? toSocialsProps(footerSocials) : undefined}
      paymentOptionsProps={footerPayments?.fields ? toPaymentProvidersProps(footerPayments) : undefined}
      legalsProps={legalsProps}
      tagline={he.decode(window.Jbhifi.tagline || '')}
    />
  );
};
